"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

export default function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <NextThemesProvider
      attribute="class"
      // Abre SEMPRE em claro no 1º acesso (não segue o tema do SO do
      // aparelho). enableSystem mantido só pra opção "Sistema" do toggle
      // continuar funcionando quando o usuário a escolhe explicitamente.
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
